@let isLg = lg();

<div matRipple
     class="wrapper"
     [class.lg]="isLg"
     [class.active]="active()"
     [style]="getBgImageStyle()"
     (click)="handleSelect()"
     (keydown.enter)="handleSelect()">
  <div class="title-row">
    <div class="title">{{ title() }}</div>
    @if (isLg) {
      <div class="arrow"></div>
    }
  </div>
</div>
